import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router'
import createRootReducer from './reducers';
import { createBrowserHistory } from 'history'


export const history = createBrowserHistory();

export default function configureStore(preloadedState) {
    const store = createStore(
        createRootReducer(history), // root reducer with router state
        preloadedState,
        compose(
            applyMiddleware(
                routerMiddleware(history), // for dispatching history actions
                thunkMiddleware
            ),
        ),
    )

    return store
}


// WEBPACK FOOTER //
// ./src/configureStore.js